/**
 * @file userPreferencesService.js
 * @description Servicio para gestionar la persistencia de configuración de tablas (Mockeado con LocalStorage)
 */

const STORAGE_KEY = 'automotive_dashboard_table_config';

// Simula un retraso de red
const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

export const userPreferencesService = {
  /**
   * Obtiene la configuración de columnas para un usuario y tabla específica
   * @param {string|number} userId - ID del usuario
   * @param {string} tableId - ID de la tabla (ej: 'T1', 'inventario_principal')
   * @returns {Promise<string[] | null>} Array de IDs de columnas o null si no existe config
   */
  getTableConfig: async (userId, tableId) => {
    await delay(300); // Simular latencia API
    
    try {
      const allConfigs = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      
      // Buscamos el registro tal cual lo definiste en tu estructura SQL
      const foundConfig = allConfigs.find(
        entry => entry.id_user === userId && entry.id_table === tableId
      );

      if (foundConfig) {
        // Tu BD guardará un string "B, D, A, C", aquí lo convertimos de vuelta a array
        return foundConfig.config.split(',').map(s => s.trim());
      }
      
      return null;
    } catch (error) {
      console.error('Error leyendo preferencias:', error);
      return null;
    }
  },

  /**
   * Guarda la configuración
   * @param {string|number} userId 
   * @param {string} tableId 
   * @param {string[]} columnsArray - Array ordenado de columnas ['vin', 'modelo', 'color']
   */
  saveTableConfig: async (userId, tableId, columnsArray) => {
    await delay(300);
    
    const allConfigs = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    const configString = columnsArray.join(','); // Convertimos a "A, B, C" para guardar como en SQL

    const existingIndex = allConfigs.findIndex(
      entry => entry.id_user === userId && entry.id_table === tableId
    );

    if (existingIndex >= 0) {
      // Update
      allConfigs[existingIndex].config = configString;
    } else {
      // Insert
      allConfigs.push({
        id: Date.now(), // Simulación de Auto-Increment ID
        id_user: userId,
        id_table: tableId,
        config: configString
      });
    }

    localStorage.setItem(STORAGE_KEY, JSON.stringify(allConfigs));
    return true;
  }
};